import { Injectable, OnDestroy } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from 'environments/environment';
import { AuthService } from '../../../../services/auth.service';
import { Subject, Observable } from 'rxjs';
//Observable

@Injectable({
  providedIn: 'root',
})
export class SocketService implements OnDestroy {
  private socket!: Socket;
  private connected = false;
  private notification$ = new Subject<any>();

  public pendingReserved$ = new Subject<any>();

  constructor(private auth: AuthService) {
    this.initConnection();
  }

  private initConnection() {
    //     Sacar token del localStorage para evitar null
    const token = localStorage.getItem('token');

    this.socket = io(environment.socketUrl, {
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: 10,
      auth: { token },
      path: '/socket.io',
    });

    this.socket.on('connect', () => {
      this.connected = true;
      console.log(`    Socket conectado: ${this.socket.id}`);
    });

    this.socket.on('disconnect', (reason: string) => {
      this.connected = false;
      console.log(`⚠️ Socket desconectado: ${reason}`);
    });

    this.socket.on(
      'pending_reserved',
      (data: { id: number; reserved_by: number | null }) => {
        this.pendingReserved$.next(data);
      },
    );
    this.socket.on('notification', (data: any) => {
      console.log('📨 Socket notification recibida', data);
      this.notification$.next(data);
    });
  }

  emit(event: string, payload?: any) {
    if (this.connected) {
      this.socket.emit(event, payload);
    }
  }

  onFulfillmentUpdate() {
    return new Observable((observer) => {
      this.socket.on('fulfillment_update', (data: any) => {
        observer.next(data);
      });
    });
  }

  ngOnDestroy(): void {
    if (this.socket) {
      this.socket.disconnect();
      console.log('🔌 Socket desconectado desde service');
    }
  }
  onNotification(): Observable<any> {
    return this.notification$.asObservable();
  }

  /** Independent event for the assistant, sharing the existing Socket.IO connection. */
  onAvatarCalendarChanged(): Observable<void> {
    return new Observable<void>((observer) => {
      const notify = () => observer.next();
      this.socket.on('avatar_calendar_changed', notify);
      return () => this.socket.off('avatar_calendar_changed', notify);
    });
  }

  joinUserRoom(userId: number) {
    if (!userId) return;

    if (this.connected) {
      this.socket.emit('join', userId);
      console.log(`    Join enviado para user_${userId}`);
    } else {
      // Espera hasta que se conecte
      this.socket.once('connect', () => {
        this.socket.emit('join', userId);
        console.log(`    Join enviado para user_${userId} tras conectar`);
      });
    }
  }
}
